import { render, staticRenderFns } from "./LeitsystemBzlu.vue?vue&type=template&id=6bebef5f&scoped=true"
import script from "./LeitsystemBzlu.vue?vue&type=script&lang=js"
export * from "./LeitsystemBzlu.vue?vue&type=script&lang=js"
import style0 from "./LeitsystemBzlu.vue?vue&type=style&index=0&id=6bebef5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bebef5f",
  null
  
)

export default component.exports